import "./TuiInputLabel.css";
export default function TuiInputLabel(props) {
  return (
    <label id={`${props.sign ?? ""}`} className="t-title t-input-label">
      {props.children}
    </label>
  );
}
